import { ConversationType } from '../enums/chat';
import { generateEntityId } from '../utils/chat';

export const CONVERSATIONS: ConversationSchema[] = [
    {
        id: 1,
        entityId: generateEntityId(ConversationType.PROJECT, '1234'),
        name: 'conv1',
        projectId: 1234,
        messages: []
    },
    {
        id: 2,
        entityId: generateEntityId(ConversationType.PROJECT, '567'),
        name: 'conv2',
        projectId: 567,
        messages: []
    },
    {
        id: 3,
        entityId: generateEntityId(ConversationType.PROJECT, '789'),
        name: 'conv3',
        projectId: 789,
        messages: []
    },
    {
        id: 4,
        entityId: generateEntityId(ConversationType.PROJECT, '135'),
        name: 'conv4',
        projectId: 135,
        messages: []
    },
    {
        id: 5,
        entityId: generateEntityId(ConversationType.PROJECT, '357'),
        name: 'conv5',
        projectId: 357,
        messages: []
    },
    {
        id: 6,
        entityId: generateEntityId(ConversationType.PROJECT, '790'),
        name: 'conv6',
        projectId: 790,
        messages: []
    }
];

export const FETCH_CONVERSATION_INTERVAL = 30000;
export const DEFAULT_INTERVAL = 10000;
export const ROUND_OFF_SCROLL_HEIGHT = 50;
export const CONVERSATION_PAGE_SIZE = 30;

const mockEntityId = generateEntityId(ConversationType.PROJECT, '2');

export const MOCK_CONVERSATION_MESSAGES: MessageSchema[] = [
    {
        id: 1,
        conversationId: 3,
        entityId: mockEntityId,
        text: 'I have an issue with project 321',
        senderAlias: 'user1',
        timestampEpochMs: 111000,
        isDeleted: false
    },
    {
        id: 2,
        conversationId: 1,
        entityId: mockEntityId,
        text: 'Hello, how are you?',
        timestampEpochMs: 111,
        isDeleted: false,
        senderAlias: 'user1'
    },
    {
        id: 3,
        conversationId: 1,
        entityId: mockEntityId,
        text: 'I am good, thanks! How about you?',
        senderAlias: 'user2',
        timestampEpochMs: 112,
        isDeleted: false,
        replyMessageId: 6
    },
    {
        id: 4,
        conversationId: 1,
        entityId: mockEntityId,
        text: 'Doing well too!',
        senderAlias: 'user1',
        timestampEpochMs: 113,
        isDeleted: false
    },
    {
        id: 5,
        conversationId: 1,
        entityId: mockEntityId,
        text: 'Have you seen the new update?',
        senderAlias: 'user2',
        timestampEpochMs: 114,
        isDeleted: false
    },
    {
        id: 6,
        conversationId: 1,
        entityId: mockEntityId,
        text: 'Yes, it looks great!',
        senderAlias: 'user1',
        timestampEpochMs: 115,
        isDeleted: false,
        replyMessageId: 9
    }
];

export const reactionEmojis = [
    { emoji: '✅', label: 'check' },
    { emoji: '👍', label: 'like' },
    { emoji: '❌', label: 'cross' }
];

export interface ConversationStateSchema {
    conversationId: number;
    entityId: string;
    conversationName: string;
    projectId?: number;
    projectName?: string;
    messages?: MessageSchema[];
    isLoading?: boolean;
    conversationError?: string;
    unreadMessageCount: number;
    replyMessage?: MessageSchema | undefined;
    lastReadMessageId: number;
    viewPageNumber: number;
    lastNonSearchPageNumber?: number;
    searchTerm?: string;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
}

export interface ChatSliceStateSchema {
    conversations: Record<number, ConversationStateSchema>;
    activeConversationId: number | null;
    activeDiscussionsTabId: string | null;
    isOpen: boolean;
    permissionsLoading: boolean;
    targetMessageId: number | null;
}

export interface ConversationSchema {
    id: number;
    entityId: string;
    name: string;
    projectId?: number;
    messages?: MessageSchema[];
}

export interface MessageAttachment {
    id: number;
    name: string;
    type: string;
}

export interface MessageSchema {
    id: number;
    conversationId: number;
    entityId: string;
    text: string;
    timestampEpochMs: number;
    isDeleted: boolean;
    replyMessageId?: number;
    replyMessage?: MessageSchema;
    senderAlias?: string;
    senderUserId?: string;
    tagId?: string;
    attachments?: MessageAttachment[];
    reactions?: { emoji: string; users: string[] }[];
}

export interface ReplyMessageSchema {
    id: number;
    conversationId: number;
    text: string;
    timestampEpochMs: number;
    isDeleted: boolean;
    senderAlias: string | null;
    senderUserId: string | null;
}

export interface UserConversationStateSchema {
    id: number;
    userId: string;
    conversationId: number;
    lastReadMessage: number;
}

export interface UserConversationSchema {
    conversationId: number;
    entityId: string;
    projectId: number;
    projectName: string;
    conversationName: string;
    lastReadMsg: number;
    unreadCount: number;
}
export interface CreateConversationResponseSchema {
    conversation: ConversationSchema;
}

export interface GetConversationResponseSchema {
    id: number;
    name: string;
    messages: MessageSchema[];
    nextCursor: boolean;
    pageFull: boolean;
}

export interface FetchMessagesResponseSchema extends GetConversationResponseSchema {
    requestId: string;
}

export interface FetchMessagesErrorSchema {
    requestId: string;
    error: string;
}

export interface CreateMessageResponseSchema {
    id: number;
    conversationId: number;
    text: string;
    replyMessageId?: number;
    senderAlias?: string;
}

export interface GetUserConversationStateResponseSchema {
    conversationId: number;
    entityId: string;
    lastReadMessageId: number;
    numUnreadMessages: number;
    pageNumber: number;
}

export interface MessageActionResponseSchema {
    message: MessageSchema;
}

export interface DeleteMessageResponseSchema {
    status: 'ok' | 'error';
    error?: string;
}

export interface GetUserPermissionsResponseSchema {
    conversations: UserConversationSchema[];
}

export type ConversationMessage = MessageSchema & {
    displayTimestamp: string;
    isOwn: boolean;
};

export type MessageReaction = {
    emoji: string;
    count: number;
    users: string[];
};
